/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 */
import request from './request';
import { serializeParams } from '../common/helpers';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(() => {
            //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return defaultData;
            //return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};


export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

const defaultData =
    {
        "_embedded": {
            "clearenceStatuses": [
                {
                    "statusName": "DISPATCHED",
                    "representation": "DESPACHADO",
                    "color": "#d67575",
                    "_links": {
                        "self": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/3ccf4b12-0e32-4b0c-b542-90997c24f708"
                        },
                        "clearenceStatus": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/3ccf4b12-0e32-4b0c-b542-90997c24f708"
                        }
                    }
                },
                {
                    "statusName": "PRE_NOTIFIED",
                    "representation": "PRE ALERTADO",
                    "color": "#d6c075",
                    "_links": {
                        "self": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/0c10cefc-5219-4a18-a747-b859d35bf8ff"
                        },
                        "clearenceStatus": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/0c10cefc-5219-4a18-a747-b859d35bf8ff"
                        }
                    }
                },
                {
                    "statusName": "IN_PROGRESS",
                    "representation": "EN PROCESO",
                    "color": "#75d692",
                    "_links": {
                        "self": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/da619c1a-c3cb-4518-9a0d-3e39efe113dd"
                        },
                        "clearenceStatus": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/da619c1a-c3cb-4518-9a0d-3e39efe113dd"
                        }
                    }
                },
                {
                    "statusName": "CLOSED",
                    "representation": "CERRADO",
                    "color": "#555",
                    "_links": {
                        "self": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/ec002fae-2cd1-4563-aa05-960582261a87"
                        },
                        "clearenceStatus": {
                            "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/ec002fae-2cd1-4563-aa05-960582261a87"
                        }
                    }
                }
            ]
        },
        "_links": {
            "self": {
                "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses"
            },
            "profile": {
                "href": "https://sicom.afsforwarding.com/afs/v1/profile/clearenceStatuses"
            },
            "search": {
                "href": "https://sicom.afsforwarding.com/afs/v1/clearenceStatuses/search"
            }
        }
    };



// WEBPACK FOOTER //
// ./services/statuses.js